import { EAppId } from "@timeedit/types/lib/enums";
import { getEndpoints } from "../RouteTypes";
import { TOrganizationPublic, TTEUser } from "@timeedit/types/lib/types";
import { useContext, useMemo } from "react";
import {
  TopBarContent,
  AuthContext,
  TopBarLayout,
} from "@timeedit/ui-components";
import { useUserData } from "../../redux/hooks";
import { useFetchTeOrganizationQuery } from "../../redux/api/te";
import { EOrganizationVisibility } from "@timeedit/types/lib/enums/organizationVisibility.enum";
import { ERegion } from "@timeedit/types/lib/enums/region.enum";
import { useFetchRegistrationQuery } from "../../redux/api/registration";
import { MenuProps } from "@timeedit/ui-components/antd";
import { urls } from "./AuthRoot";
import { useNavigate } from "react-router-dom";

interface ResponsiveTopBarProps {
  isDesktop: boolean;
}

export function ResponsiveTopBar({
  isDesktop,
}: ResponsiveTopBarProps): React.JSX.Element {
  const navigate = useNavigate();

  const user = useUserData();
  const org = useFetchTeOrganizationQuery(
    { organizationId: user.data?.organizationId },
    { skip: user.isLoading || user.isError }
  );

  const logout =
    useContext(AuthContext)?.logout ?? (() => alert("Logout failed"));

  const ENDPOINTS = getEndpoints();
  const navigation = isDesktop
    ? [
        {
          key: "registration-key",
          label: "Registration",
          path: `${ENDPOINTS.registration.path}`,
          visible: true,
        },
        {
          key: "schedule-key",
          label: "Schedule",
          path: `${ENDPOINTS.schedule.path}`,
          visible: true,
        },
      ]
    : [];

  const userData = user.isSuccess ? user.data : undefined;
  const organization = org.isSuccess
    ? {
        ...org.data,
        visibility: EOrganizationVisibility.PUBLIC,
        region: org.data.region ?? ERegion.EU_EES,
      }
    : ({} as TOrganizationPublic);

  const registration = useFetchRegistrationQuery();
  const timezone = registration.data?.timezone;

  const dropdownMenuItems = useMemo<MenuProps>(
    () => ({
      items: [
        {
          label: (
            <span>
              {timezone?.user.extId} {timezone?.user.name}{" "}
              {timezone?.user.offset}
            </span>
          ),
          type: "group",
          key: "timezone",
        },
      ],
    }),
    [timezone]
  );

  const parts = {
    left: (
      <>
        <TopBarContent.OrganizationLogo organization={organization} />
        <TopBarContent.OrganizationName organization={organization} />
        <TopBarContent.EnvTag appEnv={import.meta.env.VITE_TE_APP_ENV} />
      </>
    ),
    center: (
      <TopBarContent.NavigationMenu
        navigation={navigation}
        selected={isDesktop ? findSelected(location.pathname) : undefined}
        onClick={(item) => navigate(item.key)}
      />
    ),
    right: (
      <TopBarContent.UserDropdown
        user={{
          avatarUrl: undefined,
          email: userData?.email || "",
          firstName: userData?.firstName,
          lastName: userData?.lastName,
          profiles: userData?.profiles as TTEUser["profiles"],
        }}
        menu={dropdownMenuItems}
        onLogout={logout}
        customerSignature={userData?.customerSignature || undefined}
        authUrl={urls.AUTH_URL}
      />
    ),
  };
  return <TopBarLayout currentProduct={EAppId.TE_REGISTRATION} slots={parts} />;

  function findSelected(includingPath: string): string | undefined {
    return navigation.find(({ path }) => includingPath.includes(path))?.path;
  }
}
